module.exports = __webpack_public_path__ + "static/media/service8.e8be6445.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/service8.jpeg
// module id = 317
// module chunks = 0